import gql from 'graphql-tag';

const ADD_INTEGRATION = gql`
  mutation($integrationId: String!, $input: IntegrationInput) {
    addIntegration(integrationId: $integrationId, input: $input) {
      integrationId
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

const UPDATE_INTEGRATION = gql`
  mutation($integrationId: String!, $input: IntegrationInput) {
    updateIntegration(integrationId: $integrationId, input: $input) {
      integrationId
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

const DELETE_INTEGRATION = gql`
  mutation($integrationId: String!) {
    deleteIntegration(integrationId: $integrationId) {
      integrationId
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

const UPDATE_DATA_MAPPING = gql`
  mutation($name: String!, $data: [DataMappingInput]!) {
    updateDataMapping(name: $name, data: $data) {
      integrationId #IntegrationType
      data
      activated
      deletionInProgress
      connectionStatus
    }
  }
`;

// the possible values for name are XERO_SUPEROPS_CLIENT, XERO_SUPEROPS_SERVICE_ITEM, WEBROOT_SITE
const INITIATE_DATA_PULL = gql`
  mutation($name: String!, $clientId: ID) {
    initiateDataPull(name: $name, clientId: $clientId) {
      integrationId #IntegrationType
      integrationRefId
      data
      activated
      deletionInProgress
      connectionStatus #ConnectionStatus
    }
  }
`;

// enum ConnectionStatus {
//   CONNECTED,
//   RECONNECT,
//   REAUTHORIZE
// }

// enum ConnectionStatus {
//   CONNECTED,
//   RECONNECT,
//   REAUTHORIZE
// }

// input DataMappingInput {
// 	source: MappingObjectInput!
// 	destination: MappingObjectInput
// 	operation: String! # DataMappingOperation
// }

// enum DataMappingOperation {
// 	CREATE
// 	MAP
//  IGNORE
// }

// input MappingObjectInput {
// 	id: ID!
// 	name: String!
// 	details: JSON
// }

// enum IntegrationType {
//   TEAM_VIEWER
//   SPLASH_TOP
//   CONNECTWISE_CONTROL
//   QUICK_BOOKS
//   WEBROOT
// }

const EXECUTE_ASSET_INTEGRATION_ACTION = gql`
  mutation($assetIds: [ID!], $integrationId: ID, $action: String) {
    executeAssetIntegrationAction(
      assetIds: $assetIds
      integrationId: $integrationId
      action: $action
    )
  }
`;

const INITIATE_WEBROOT_ACTION = gql`
  mutation($assetId: ID!, $action: String!) {
    initiateWebrootAction(assetId: $assetId, action: $action)
  }
`;
const INITIATE_ACRONIS_ACTION = gql`
  mutation($assetId: ID!, $action: String!) {
    invokeAcronisAssetActions(assetId: $assetId, action: $action)
  }
`;

const INITIATE_BITDEFENDER_ACTION = gql`
  mutation($assetId: ID!, $action: String!) {
    invokeBitDefenderAssetActions(assetId: $assetId, action: $action)
  }
`;

// enum WebrootAction {
// 	SCAN
// 	CLEANUP
// 	UNINSTALL
// }

const UPDATE_INTEGRATION_CONFIG_FOR_CLIENTS = gql`
  mutation($integrationId: ID, $clientIntegrationInfoInput: [ClientInput]) {
    updateIntegrationConfigForClients(
      integrationId: $integrationId
      clientIntegrationInfoInput: $clientIntegrationInfoInput
    )
  }
`;

const INIT_INVOICE_PAYMENT = gql`
  mutation($invoiceId: ID!) {
    initInvoicePayment(invoiceId: $invoiceId)
  }
`;

const CONFIRM_INVOICE_PAYMENT = gql`
  mutation($paymentIntentId: String!) {
    confirmInvoicePayment(paymentIntentId: $paymentIntentId)
  }
`;

const INIT_ADD_PAYMENT_TYPE = gql`
  mutation($clientId: ID!) {
    initAddPaymentType(clientId: $clientId)
  }
`;

const CONFIRM_ADD_PAYMENT_TYPE = gql`
  mutation($setupIntentId: String!) {
    confirmAddPaymentType(setupIntentId: $setupIntentId)
  }
`;

const UPDATE_PAYMENT_SETTING = gql`
  mutation($clientId: ID!, $setting: PaymentSettingInput!) {
    updatePaymentSetting(clientId: $clientId, setting: $setting) {
      clientId
      autoProcessPayment
      paymentMethodId
      paymentMethod
    }
  }
`;

const UPDATE_CLIENT_PAYMENT_CONFIGURATION = gql`
  mutation($input: ClientPaymentConfigurationInput!) {
    updateClientPaymentConfiguration(input: $input) {
      clientId
      autoProcessPayment
      paymentSourceId
      paymentMethod
    }
  }
`;

// input PaymentSettingInput {
//   autoProcessPayment: Boolean
//   paymentId: String
// }

const ADD_ACH_ACCOUNT = gql`
  mutation($clientId: ID!, $token: String) {
    addACHAccount(clientId: $clientId, token: $token) {
      id
      routingNumber
      bankName
      isVerified
      last4
    }
  }
`;

const VALIDATE_ACH_ACCOUNT = gql`
  mutation($input: ValidateACHAccountInput) {
    validateACHAccount(input: $input) {
      id
      routingNumber
      bankName
      isVerified
      last4
    }
  }
`;

// type ACHAccount {
//   id: ID!
//   routingNumber: String
//   bankName: String
//   isVerified: Boolean
//   last4: String
// }

const SETUP_INTEGRATED_PAYMENT = gql`
  mutation($input: SetupIntegratedPaymentMethodInput!) {
    setupIntegratedPaymentMethod(input: $input)
  }
`;

const CONFIRM_INTEGRATED_PAYMENT = gql`
  mutation($setupIntentId: String!) {
    confirmIntegratedPaymentMethod(setupIntentId: $setupIntentId)
  }
`;
const MIGRATE_HALOPSA_INTEGRATION = gql`
  mutation {
    migrateIntegration(integrationId: "HALO_PSA") {
      integrationId
      integrationRefId
      data
      activated
      deletionInProgress
      connectionStatus
    }
  }
`;

export {
  ADD_INTEGRATION,
  UPDATE_INTEGRATION,
  DELETE_INTEGRATION,
  UPDATE_DATA_MAPPING,
  INITIATE_DATA_PULL,
  INITIATE_WEBROOT_ACTION,
  UPDATE_INTEGRATION_CONFIG_FOR_CLIENTS,
  INIT_INVOICE_PAYMENT,
  CONFIRM_INVOICE_PAYMENT,
  INIT_ADD_PAYMENT_TYPE,
  CONFIRM_ADD_PAYMENT_TYPE,
  UPDATE_PAYMENT_SETTING,
  UPDATE_CLIENT_PAYMENT_CONFIGURATION,
  ADD_ACH_ACCOUNT,
  INITIATE_BITDEFENDER_ACTION,
  SETUP_INTEGRATED_PAYMENT,
  CONFIRM_INTEGRATED_PAYMENT,
  VALIDATE_ACH_ACCOUNT,
  EXECUTE_ASSET_INTEGRATION_ACTION,
  MIGRATE_HALOPSA_INTEGRATION,
  INITIATE_ACRONIS_ACTION
};
